/* RL Store — secções editoriais (2026-08-10)
   1) adicionar ao carrinho a partir de um cartão ou de uma rotina inteira
   2) abrir/fechar as janelas das rotinas
   Tudo por delegação de eventos, para funcionar com conteúdo reinjetado pelo editor do tema. */
(() => {
  if (window.__rlEditorialReady) return;
  window.__rlEditorialReady = true;

  const juntarAoCarrinho = async (itens) => {
    const resposta = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itens })
    });
    if (!resposta.ok) throw new Error('cart');

    const carrinho = await fetch('/cart.js').then((r) => r.json());
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: carrinho, data: { itemCount: carrinho.item_count, source: 'rl-editorial' } }
      })
    );
    return carrinho;
  };

  const comFeedback = async (botao, itens, textoFinal) => {
    if (!itens.length || botao.disabled) return;
    const original = botao.innerHTML;
    botao.disabled = true;
    botao.textContent = 'A adicionar…';
    try {
      await juntarAoCarrinho(itens);
      botao.textContent = textoFinal;
      setTimeout(() => {
        botao.innerHTML = original;
        botao.disabled = false;
      }, 1800);
    } catch (erro) {
      botao.innerHTML = original;
      botao.disabled = false;
    }
  };

  // --- carrosséis: setas e estado das setas ---
  const pista = (el) => el.closest('[data-rl-carousel]')?.querySelector('.rl-carousel__track');
  const acertarSetas = (track) => {
    const caixa = track.closest('[data-rl-carousel]');
    if (!caixa) return;
    const fim = track.scrollWidth - track.clientWidth - 2;
    caixa.querySelectorAll('[data-rl-prev]').forEach((b) => (b.disabled = track.scrollLeft <= 2));
    caixa.querySelectorAll('[data-rl-next]').forEach((b) => (b.disabled = track.scrollLeft >= fim));
  };
  document.addEventListener('scroll', (e) => {
    if (e.target instanceof Element && e.target.matches('.rl-carousel__track')) acertarSetas(e.target);
  }, true);
  const iniciarCarrosseis = () => document.querySelectorAll('.rl-carousel__track').forEach(acertarSetas);
  document.addEventListener('DOMContentLoaded', iniciarCarrosseis);
  window.addEventListener('load', iniciarCarrosseis);
  document.addEventListener('shopify:section:load', iniciarCarrosseis);

  // --- passos da rotina: separadores ---
  const mostrarPasso = (botao) => {
    const caixa = botao.closest('[data-rl-steps]');
    if (!caixa) return;
    caixa.querySelectorAll('[data-rl-step-tab]').forEach((b) => b.setAttribute('aria-selected', String(b === botao)));
    caixa.querySelectorAll('[data-rl-step-panel]').forEach((p) => (p.hidden = p.id !== botao.getAttribute('aria-controls')));
    const aberto = caixa.querySelector('#' + CSS.escape(botao.getAttribute('aria-controls')));
    aberto?.querySelectorAll('.rl-carousel__track').forEach((t) => { t.scrollLeft = 0; acertarSetas(t); });
  };

  document.addEventListener('click', async (evento) => {
    const seta = evento.target.closest('[data-rl-prev], [data-rl-next]');
    if (seta) {
      const track = pista(seta);
      if (track) {
        const passo = track.clientWidth * 0.9 * (seta.hasAttribute('data-rl-prev') ? -1 : 1);
        track.scrollBy({ left: passo, behavior: 'smooth' });
      }
      return;
    }

    const separador = evento.target.closest('[data-rl-step-tab]');
    if (separador) {
      mostrarPasso(separador);
      return;
    }

    // --- abrir uma janela de rotina ---
    const abrir = evento.target.closest('[data-rl-open]');
    if (abrir) {
      const janela = document.getElementById(abrir.dataset.rlOpen);
      if (janela && typeof janela.showModal === 'function') {
        evento.preventDefault();
        janela.showModal();
      }
      return;
    }

    // --- fechar ---
    const fechar = evento.target.closest('[data-rl-close]');
    if (fechar) {
      fechar.closest('dialog')?.close();
      return;
    }

    // --- clicar no fundo escuro fecha ---
    if (evento.target.matches('dialog[data-rl-modal]')) {
      evento.target.close();
      return;
    }

    // --- juntar um produto ---
    const um = evento.target.closest('[data-rl-add]');
    if (um) {
      evento.preventDefault();
      await comFeedback(um, [{ id: Number(um.dataset.rlAdd), quantity: 1 }], 'Adicionado ✓');
      return;
    }

    // --- juntar a rotina toda ---
    const varios = evento.target.closest('[data-rl-add-many]');
    if (varios) {
      evento.preventDefault();
      const itens = (varios.dataset.rlAddMany || '')
        .split(',')
        .filter(Boolean)
        .map((id) => ({ id: Number(id), quantity: 1 }));
      await comFeedback(varios, itens, 'Rotina adicionada ✓');
    }
  });
})();
